function SmallCarousel({ root }) {
  this.root = root;
  this.trackWidth = 0;
  this.viewportWidth = 0;
  this.slideDuration = 0.25;
  this.singleSlideWidth = 0;
  this.gap = 40;
  // Gsap Timeline
  this.tl = gsap.timeline({
    repeat: 0,
  });

  this.init();
  this.registerDrag();
  this.animate();
  this.registerSlider();
  this.registerButtons();
  this.tl.pause();
}

SmallCarousel.prototype.init = function () {
  const track = this.root.querySelector(".track");
  this.viewportWidth = getWidth(this.root.querySelector(".viewport"));
  this.trackWidth = getWidth(track);
};

SmallCarousel.prototype.registerDrag = function () {
  let x = 0;

  const track = this.root.querySelector(".track");
  const trackWidth = this.trackWidth;
  const viewportWidth = this.viewportWidth;
  const tl = this.tl;
  const totalTimelineWidth = trackWidth - viewportWidth;
  const slideDuration = this.slideDuration;
  let translateX = 0;
  let toProgress = 0;

  let isDragging = false;

  function getIsDragging() {
    return isDragging;
  }

  const mouseDownHandler = function (e) {
    const clientX = e.clientX !== undefined ? e.clientX : e.touches[0].clientX;
    x = clientX;
    translateX = getTranslateX(track);

    toProgress = gsap.utils.mapRange(
      0,
      totalTimelineWidth,
      0,
      1,
      gsap.utils.clamp(0, totalTimelineWidth, -translateX)
    );

    document.addEventListener("mousemove", mouseMoveHandler);
    document.addEventListener("click", mouseUpHandler);

    document.addEventListener("touchmove", mouseMoveHandler);
    document.addEventListener("touchend", mouseUpHandler);

    gsap.ticker.add(dragTicker);
  };

  const mouseMoveHandler = function (e) {
    isDragging = true;
    const clientX = e.clientX !== undefined ? e.clientX : e.touches[0].clientX;
    const dx = clientX - x;
    toProgress = gsap.utils.mapRange(
      0,
      totalTimelineWidth,
      0,
      1,
      gsap.utils.clamp(0, totalTimelineWidth, -(translateX + dx))
    );
  };

  const mouseUpHandler = function (e) {
    isDragging = false;
    gsap.ticker.remove(dragTicker);

    const tween = tl.tweenTo(
      Math.round(tl.time() / slideDuration) * slideDuration,
      { ease: "linear" }
    );
    tween.restart();

    document.removeEventListener("mousemove", mouseMoveHandler);
    document.removeEventListener("click", mouseUpHandler);

    document.removeEventListener("touchmove", mouseMoveHandler);
    document.removeEventListener("touchend", mouseUpHandler);
  };

  function dragTicker() {
    tl.totalProgress(toProgress);
  }

  this.root.querySelectorAll("a > div").forEach((element) => {
    element.addEventListener("mousedown", mouseDownHandler);
    element.addEventListener("touchstart", mouseDownHandler);
  });

  this.root.querySelectorAll("a").forEach((element) => {
    element.addEventListener("click", function (e) {
      if (getIsDragging()) {
        e.preventDefault();
      }
    });
  });

  track.addEventListener("mousedown", mouseDownHandler);
  track.addEventListener("touchstart", mouseDownHandler);
};

SmallCarousel.prototype.animate = function () {
  const track = this.root.querySelector(".track");

  this.tl.to(track, {
    x: -parseFloat(this.trackWidth - this.viewportWidth),
    duration: (this.trackWidth / this.viewportWidth) * this.slideDuration,
    ease: "linear",
  });
};

SmallCarousel.prototype.registerSlider = function () {
  const sliderInner = this.root.querySelector(".slider-inner");
  const duration = this.tl.duration();
  const trackWidth = this.trackWidth;
  const viewportWidth = this.viewportWidth;

  this.tl.fromTo(
    sliderInner,
    {
      width: (viewportWidth / trackWidth) * 100 + "%",
    },
    {
      width: "100%",
      duration: duration,
      ease: "linear",
    },
    0
  );
};

SmallCarousel.prototype.registerButtons = function () {
  const prevButton = this.root.querySelector(".prev-button");
  const nextButton = this.root.querySelector(".next-button");
  const tl = this.tl;
  const slideDuration = this.slideDuration;

  this.tl.fromTo(
    prevButton,
    {
      scale: 0.5,
      opacity: 0,
      display: "none",
    },
    {
      scale: 1,
      opacity: 1,
      display: "block",
      duration: this.slideDuration / 3,
      ease: "linear",
    },
    0
  );

  this.tl.fromTo(
    nextButton,
    {
      scale: 1,
      opacity: 1,
      display: "block",
    },
    {
      scale: 0.5,
      opacity: 0,
      display: "none",
      duration: this.slideDuration / 3,
      ease: "linear",
    },
    this.tl.duration() - this.slideDuration / 3
  );

  prevButton.addEventListener("click", function () {
    // This calculation is for preventing click spamming on the prev button
    // Even if the user spams prev button carousel will animate to exact interval
    const prevTime =
      Math.round(tl.time() / slideDuration) * slideDuration - slideDuration;

    const tween = tl.tweenTo(prevTime, { ease: "linear" });
    tween.restart();
  });

  nextButton.addEventListener("click", function () {
    // This calculation is for preventing click spamming on the next button
    // Even if the user spams next button carousel will animate to exact interval
    const nextTime =
      Math.round(tl.time() / slideDuration) * slideDuration + slideDuration;

    const tween = tl.tweenTo(nextTime, { ease: "linear" });
    tween.restart();
  });
};
